import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { AudioPlayer } from '@/components/audio-player';
import { CallCategoryBadge, CallHumanRequestedBadge, CallOutcomeClientBadge } from '@/components/call/call-badges';
import { ApiSchemas } from '@/components/providers/v1-api';
import { formatPhoneNumber } from '@/lib/format';

type CallListItem = ApiSchemas['CallRead'];

export const CALL_COLUMNS: ColumnDef<CallListItem>[] = [
  {
    accessorKey: 'from_number',
    header: 'Phone Number',
    cell: ({ row }) => {
      const phoneNumber = formatPhoneNumber(row.original.from_number);
      return <div className='font-medium'>{phoneNumber}</div>;
    },
  },
  {
    accessorKey: 'start_timestamp',
    header: 'Start Time',
    cell: ({ row }) => {
      const startTimestamp = row.original.start_timestamp;
      const startDate = new Date(startTimestamp);
      return <div>{format(startDate, 'MMM d, hh:mm a')}</div>;
    },
  },
  {
    accessorKey: 'recording_url',
    header: 'Recording',
    cell: ({ row }) => {
      const recordingUrl = row.original.recording_url;
      if (!recordingUrl) return null;
      return <AudioPlayer url={recordingUrl} className='h-8' />;
    },
  },
  {
    accessorKey: 'duration_ms',
    header: 'Duration',
    cell: ({ row }) => {
      const duration = (row.original.duration_ms ?? 0) / 1000;
      return <div>{duration.toFixed(0)}s</div>;
    },
  },
  {
    accessorKey: 'analysis.intent.name',
    header: 'Category',
    cell: ({ row }) => {
      return <CallCategoryBadge call={row.original} />;
    },
  },
  {
    accessorKey: 'analysis.outcome_client.result',
    header: 'Outcome',
    cell: ({ row }) => {
      return <CallOutcomeClientBadge call={row.original} />;
    },
  },
  {
    accessorKey: 'analysis.human_request.result',
    header: 'Human Requested',
    cell: ({ row }) => {
      return <CallHumanRequestedBadge call={row.original} />;
    },
  }
];
